import { type FunctionComponent } from 'react';
import { SvgIcon, type SvgIconProps } from './SvgIcon';

export const StreamCloseIcon: FunctionComponent<SvgIconProps> = (props) => {
  return (
    <SvgIcon height="27" viewBox="0 0 27 27" width="27" {...props}>
      <path
        clipRule="evenodd"
        d="M7.93156 7.93156C7.49222 8.37089 7.49222 9.08321 7.93156 9.52255L11.909 13.5L7.93157 17.4775C7.49223 17.9168 7.49223 18.6292 7.93157 19.0685C8.37091 19.5078 9.08322 19.5078 9.52256 19.0685L13.5 15.091L17.4775 19.0685C17.9168 19.5078 18.6291 19.5078 19.0685 19.0685C19.5078 18.6291 19.5078 17.9168 19.0685 17.4775L15.091 13.5L19.0685 9.52255C19.5078 9.08321 19.5078 8.3709 19.0685 7.93156C18.6292 7.49222 17.9168 7.49222 17.4775 7.93156L13.5 11.909L9.52255 7.93156C9.08321 7.49222 8.37089 7.49222 7.93156 7.93156Z"
        fill="currentcolor"
        fillRule="evenodd"
      />
    </SvgIcon>
  );
};
